import React from "react";
import { Link } from "react-router-dom";
import MusicShell from "../fanHome/MusicShell";
import { ACCENT } from "../artistStudio/shared";

// /rights: the fan's Rights & legal hub (mobile design, screen 37): report a problem with a sound, read how commercial use works,
// answer a takedown, and open the policies. File a notice and Ownership claim need a signed-in account (the rights API requires it).
const REPORT = [
  { to: "/rights/notice", title: "Copyright takedown notice", note: "Say a sound uses your work without permission. Sign in to file it." },
  { to: "/rights/takedown", title: "Takedown without signing in", note: "No account? Send a copyright notice with your email." },
  { to: "/rights/dispute", title: "Ownership claim", note: "Say you own or co-own a sound on Nyawoo." },
  { to: "/rights/report-audio", title: "Report audio", note: "Say a sound has unmarked explicit content, is misleading, offensive or spam. Sign in to send it." },
  { to: "/rights/commercial-use", title: "Commercial-use availability", note: "What Personal, Creator and Business licences allow." },
  { to: "/rights/privacy-request", title: "State privacy rights", note: "Ask to see, delete or correct your data, or opt out of its sale (US states). Sign in to send it." },
  { to: "/rights/counter-notice", title: "Counter-notification", note: "Answer a copyright notice filed against your sound. Submitting starts the restoration timer." },
  { to: "/rights/licences-needed", title: "Licences you need", note: "Videos you posted that use a sound which needs a licence for your account type." },
  { to: "/rights/notices", title: "Take-down updates", note: "What happened to licences and videos you have when the rights to a sound were questioned." },
  { to: "/rights-cases", title: "My cases", note: "Notices, counter-notices and ownership disputes you filed or received." },
];

export const POLICIES = [
  { slug: "terms", title: "Terms of Service" },
  { slug: "dmca", title: "DMCA / Copyright Policy" },
  { slug: "community-guidelines", title: "Community Guidelines" },
  { slug: "privacy", title: "Privacy Policy" },
];

const Chevron = () => <svg viewBox="0 0 24 24" className="h-4 w-4 shrink-0 text-gray-400" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true"><path d="m9 6 6 6-6 6" /></svg>;

function Row({ to, title, note }) {
  return (
    <li>
      <Link to={to} className="flex items-center justify-between gap-3 rounded-2xl border border-gray-200 bg-white px-4 py-3.5 hover:bg-gray-50">
        <span className="min-w-0">
          <span className="block font-semibold text-gray-900">{title}</span>
          {note && <span className="mt-0.5 block text-sm text-gray-500">{note}</span>}
        </span>
        <Chevron />
      </Link>
    </li>
  );
}

export default function RightsHub() {
  return (
    <MusicShell maxWidth="max-w-3xl">
      <h1 className="text-2xl md:text-3xl font-bold text-gray-900">Rights &amp; legal</h1>
      <p className="mt-1 text-gray-600">Report a problem with a sound or read our policies.</p>
      <ul className="mt-6 space-y-3" data-testid="rights-report-list">{REPORT.map((r) => <Row key={r.title} {...r} />)}</ul>
      <h2 className="mt-8 text-lg font-bold" style={{ color: ACCENT }}>Legal &amp; policies</h2>
      <ul className="mt-3 space-y-3" data-testid="rights-policy-list">
        {POLICIES.map((p) => <Row key={p.slug} to={`/rights/policies/${p.slug}`} title={p.title} />)}
      </ul>
    </MusicShell>
  );
}
